<template>
  <div key="home_page" class="page page-home">
    <h2 class="page-header">Weather at a Glance</h2>
    <div class="search-box">
        <input type="text" placeholder="search.." v-model="text" />
        <button type="button" @click="handleOnClick">Search!</button>
    </div>
    <Weather v-for="city in cities" :key="'weather_for_'+city.woeid" :city="city.name" :woeid="String(city.woeid)" />
</div>
</template>

<script>
// @ is an alias to /src
import Weather from '@/components/Weather.vue'

const cities = [
    /*{name: 'Istanbul', woeid: 2344116},*/
    {name: 'Athens', woeid: 946738},
    {name: 'Beijing', woeid: 2151330},
    {name: 'Berlin', woeid: 638242},
    {name: 'Cairo', woeid: 1521894},
    {name: 'London', woeid: 44418},
    {name: 'Madrid', woeid: 766273},
    {name: 'Moscow', woeid: 2122265},
    {name: 'New Delhi', woeid: 28743736},
    {name: 'New York', woeid: 2459115},
    {name: 'Paris', woeid: 615702},
    {name: 'Sydney', woeid: 1105779},
    /*{name: 'Helsinki', woeid: 565346},
    {name: 'Dublin', woeid: 560743},
    {name: 'Vancouver', woeid: 9807}*/
];

export default {
  name: 'home',
  components: {
    Weather
  },
  data: function(){
    return {
        text: '',
        cities: cities
    };
  },
  methods: {
    handleOnClick: function() {
        this.$router.push({ name: 'search', params: { term: encodeURIComponent(this.text.toLowerCase()) } });
    }
  }
}
</script>
